import React from 'react';
import { Link } from 'react-router-dom';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Icon from '@material-ui/core/Icon';
import ListItem from '@material-ui/core/ListItem';
import isEmpty from 'helpers/isEmpty';
import FirstLevel from './components/FirstLevel';
import SecondLevel from './components/SecondLevel';
import fontDefault from './components/fontDefault';
import disabledMenu from './components/disabledMenu';
import { styles } from './styles';

class ListMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: this.isInitiateOpened(),
      selectedIndex: this.props.location.pathname,
      isClicked: false,
    };
  }

  isInitiateOpened = () => {
    return this.props.level === 0;
  };

  handleClick = (id, disabled, hasChildren = false) => {
    const { handleDrawerOpen, handleDrawerClose } = this.props;
    if (!disabled) {
      if (this.state.open && !this.props.open && hasChildren) {
        this.setState({ open: true, selectedIndex: id, isClicked: true }, () =>
          handleDrawerOpen()
        );
      } else if (this.isSelectedAndOpen(id) && this.props.open && hasChildren) {
        this.setState({
          selectedIndex: this.isSelectedAndOpen(id) ? null : id,
          isClicked: true,
          open: !this.state.open,
        });
      } else if (this.isSelectedAndOpen(id) && this.props.open) {
        if (id != this.state.selectedIndex) {
          this.setState({ open: !this.state.open, isClicked: false });
        }
      } else {
        this.setState(
          { open: true, selectedIndex: id, isClicked: true },
          () => {
            if (!hasChildren) {
              handleDrawerClose();
            }
          }
        );
      }
    }
  };

  isSelectedAndOpen = id => {
    return this.state.open && this.state.selectedIndex === id;
  };

  isDisabled(item = {}) {
    return item.disabled || this.props.disabled;
  }

  otherLevels = (item, id, to, isDisabled, level) => {
    const { classes } = this.props;
    const isSelectedAndOpen = this.isSelectedAndOpen(item.link);
    const selectedItemClass = isSelectedAndOpen
      ? { root: classes.subsubItemSelected }
      : { root: classes.noSelectedItem };

    return (
      <div key={item.id} data-test={item.name}>
        <Link
          classes={{ root: classes.subsubItem }}
          to={!isDisabled ? to : undefined}
          style={disabledMenu(isDisabled)}
          onClick={() => this.handleClick(item.link, isDisabled, false)}
        >
          <ListItem
            selected={isSelectedAndOpen}
            classes={{
              selected: classes.subsubItem,
              root: classes.root,
            }}
            disabled={isDisabled}
          >
            <ListItemIcon>
              <Icon />
            </ListItemIcon>
            <ListItemText classes={selectedItemClass}>
              <Typography
                noWrap
                classes={selectedItemClass}
                style={{ ...fontDefault, fontSize: '12px' }}
              >
                {item.label}
              </Typography>
            </ListItemText>
          </ListItem>
        </Link>
      </div>
    );
  };

  render() {
    const {
      level,
      menuTree,
      classes,
      isWithoutDealer,
      disabledAll,
      open,
    } = this.props;

    const isFirstLevel = level === 0;
    const isSecondLevel = level === 1;
    return (
      <List classes={isFirstLevel ? { root: classes.firstLevel } : undefined}>
        {menuTree &&
          menuTree.map((item, id) => {
            const isDisabled =
              isWithoutDealer || this.isDisabled(item) || disabledAll;
            const to = !(item.disabled || this.props.disabled) ? item.link : '';
            const externalLink = item.externalLink;
            const hasChildren = !isEmpty(item.children);
            const isSelectedAndOpen = this.isSelectedAndOpen(item.link);
            if (isFirstLevel) {
              return (
                <FirstLevel
                  key={item.id}
                  hasChildren={hasChildren}
                  item={item}
                  id={id}
                  to={to}
                  externalLink={externalLink}
                  isDisabled={isDisabled}
                  level={level}
                  handleClick={this.handleClick}
                  isSelectedAndOpen={isSelectedAndOpen}
                  isSelectedAndOpenFunction={this.isSelectedAndOpen}
                  isClicked={this.state.isClicked}
                  open={open}
                  selectedIndex={this.state.selectedIndex}
                  {...this.props}
                />
              );
            } else if (isSecondLevel) {
              return (
                <SecondLevel
                  key={item.id}
                  hasChildren={hasChildren}
                  item={item}
                  id={id}
                  to={to}
                  externalLink={externalLink}
                  isDisabled={isDisabled}
                  level={level}
                  handleClick={this.handleClick}
                  isSelectedAndOpen={isSelectedAndOpen}
                  isSelectedAndOpenFunction={this.isSelectedAndOpen}
                  isClicked={this.state.isClicked}
                  open={open}
                  selectedIndex={this.state.selectedIndex}
                  {...this.props}
                />
              );
            }
            return this.otherLevels(item, id, to, isDisabled, level);
          })}
      </List>
    );
  }
}

export default withStyles(styles)(ListMenu);
